<template>
  <div class="nav-bar">
    <div class="nav-items">
      <div 
        class="nav-item" 
        :class="{ active: activePage === 'listen' }" 
        @click="navigateTo('listen')"
      >
        听
      </div>
      <div 
        class="nav-item" 
        :class="{ active: activePage === 'watch' }" 
        @click="navigateTo('watch')"
      >
        看
      </div>
      <div 
        class="nav-item" 
        :class="{ active: activePage === 'about' }" 
        @click="navigateTo('about')"
      >
        了解我们
      </div>
    </div>
    <div class="auth-buttons">
      <template v-if="isAuthenticated">
        <div v-if="isAdmin" class="auth-button admin-button" @click="navigateTo('admin')">管理控制台</div>
        <div class="auth-button">{{ currentUser.username }}</div>
        <div class="auth-button" @click="handleLogout">退出</div>
      </template>
      <template v-else>
        <div 
          class="auth-button" 
          :class="{ active: activePage === 'login' }" 
          @click="navigateTo('login')"
        >
          登录
        </div>
        <div 
          class="auth-button" 
          :class="{ active: activePage === 'register' }" 
          @click="navigateTo('register')"
        >
          注册
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { computed } from 'vue'

export default {
  name: 'NavBar',
  props: {
    activePage: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const store = useStore()
    const router = useRouter()
    
    const isAuthenticated = computed(() => store.getters.isAuthenticated)
    const isAdmin = computed(() => store.getters.isAdmin)
    const currentUser = computed(() => store.getters.currentUser)
    
    const navigateTo = (route) => {
      if (route === props.activePage) return
      
      router.push(`/${route === 'listen' ? '' : route}`)
    }
    
    const handleLogout = () => {
      store.commit('logout')
      router.push('/login')
    }
    
    return {
      isAuthenticated,
      isAdmin,
      currentUser,
      navigateTo,
      handleLogout
    }
  }
}
</script>

<style scoped>
.nav-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 24px;
  border-bottom: 1px solid #eee;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.nav-items {
  display: flex;
  gap: 40px;
}

.nav-item {
  font-size: 20px;
  font-weight: 500;
  cursor: pointer;
  padding: 4px 8px;
  position: relative;
}

.nav-item.active {
  font-weight: bold;
}

.nav-item.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #000;
}

.auth-buttons {
  display: flex;
  gap: 20px;
}

.auth-button {
  cursor: pointer;
  font-size: 16px;
  padding: 4px 8px;
}

.auth-button.active {
  font-weight: bold;
  position: relative;
}

.auth-button.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #000;
}

.admin-button {
  color: #e74c3c;
  font-weight: bold;
}
</style> 